
export const API_DOMAIN = "https://rrunn99.com";
//export const API_DOMAIN = "http://localhost:9999/metro99.life/";